import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoupleCheck: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="douple-check"><path d="M1.75 14.7187L7.51961 19.25L18.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.5195 19.25L22.2499 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDoupleCheck;
